import { render, staticRenderFns } from "./UserClassifyView.vue?vue&type=template&id=3dccc67e&scoped=true&"
import script from "./UserClassifyView.vue?vue&type=script&lang=js&"
export * from "./UserClassifyView.vue?vue&type=script&lang=js&"
import style0 from "./UserClassifyView.vue?vue&type=style&index=0&id=3dccc67e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dccc67e",
  null
  
)

export default component.exports